"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var dateUtils_1 = require("../../../../youwell-common/dateUtils");
var constants_1 = require("../constants");
var icons_1 = require("../../../../common/icons");
var image_1 = require("../../../../common/image");
var urls_1 = __importDefault(require("../../../../app/urls"));
var useStyles = (0, core_1.makeStyles)(function (theme) { return ({
    root: {
        marginTop: theme.spacing(2),
    },
    headerCell: {
        color: theme.palette.primary.main,
        padding: 0,
    },
    padCell: {
        minWidth: 30,
        height: theme.spacing(3),
    },
    noRegistrationsHeader: {
        border: 'none',
    },
    dateLink: {
        display: 'inline-block',
        textAlign: 'left',
        padding: theme.spacing(0.5, 1),
        width: '100%',
        borderRadius: theme.youwell.shapes.borderRadiusFlatter,
        '&:hover': {
            background: theme.youwell.colors.secondaryBackground,
            boxShadow: theme.shadows[2],
        },
    },
    headerDay: {
        textTransform: 'capitalize',
    },
    labelSection: {
        textAlign: 'center',
        fontWeight: 500,
        width: 200,
    },
    valueSection: {
        textAlign: 'center',
        borderLeft: theme.youwell.borders.dim,
    },
    noPadding: {
        padding: 0,
    },
    labelWrapper: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
    },
    sleepEfficiency: {
        width: 'calc(100% - 16px)',
        display: 'inline-block',
        borderRadius: theme.youwell.shapes.borderRadiusFlatter,
        color: theme.palette.common.white,
        margin: theme.spacing(1),
        padding: theme.spacing(1, 0),
        '&$high': {
            background: theme.youwell.colors.hightScore,
        },
        '&$mid': {
            background: theme.youwell.colors.midScore,
        },
        '&$low': {
            background: theme.youwell.colors.lowScore,
        },
    },
    high: {},
    mid: {},
    low: {},
    divider: {
        borderBottom: theme.youwell.borders.normal,
    },
    icons: {
        marginLeft: theme.spacing(2),
        verticalAlign: 'middle',
    },
    actionRow: {
        cursor: 'pointer',
        background: theme.youwell.colors.defaultBackground,
        '&:hover': {
            background: theme.youwell.colors.secondaryBackground,
        },
    },
}); }, { name: 'SleepDetailsTable' });
var SleepDetailsTable = function (_a) {
    var data = _a.data, hasRegistrations = _a.hasRegistrations;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var _b = React.useState(false), showFullDetails = _b[0], setShowFullDetails = _b[1];
    var getQualityScore = function (day) {
        var score = Number((day.totalSleepMinutes || 0) / (day.totalBedMinutes || 1));
        if (score >= 0.85)
            return classes.high;
        if (score >= 0.80)
            return classes.mid;
        return classes.low;
    };
    return (React.createElement(core_1.Table, { className: classes.root },
        React.createElement(core_1.TableHead, null,
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.headerCell }),
                data.map(function (day) {
                    var _a;
                    var _b;
                    return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.labelSection, classes.headerCell, (_a = {}, _a[classes.noRegistrationsHeader] = !hasRegistrations, _a)) },
                        React.createElement(core_1.ButtonBase, { className: classes.dateLink, component: react_router_dom_1.Link, to: "".concat(urls_1.default.inside.pages.sleepDiary, "/log/").concat(day.isoDateString), title: translate('sleepDiary.editDetailsFor', { date: (0, dateUtils_1.longDate)(day.isoDateString, translate) }) },
                            React.createElement(core_1.Typography, { variant: "body2", color: "inherit", className: classes.headerDay }, translate("time.weekdays_short.".concat((_b = (0, dateUtils_1.getLocalDate)(day.isoDateString)) === null || _b === void 0 ? void 0 : _b.getDay()))),
                            React.createElement(core_1.Typography, { variant: "body2", color: "inherit" }, (0, dateUtils_1.shortDate)(day.isoDateString, translate, false, false, true)))));
                }))),
        React.createElement(core_1.TableBody, null, !hasRegistrations ? (React.createElement(core_1.TableRow, null,
            React.createElement(core_1.TableCell, { className: classes.padCell }),
            React.createElement(core_1.TableCell, { colSpan: data.length }),
            React.createElement(core_1.TableCell, { className: classes.padCell }))) : (React.createElement(React.Fragment, null,
            React.createElement(core_1.TableRow, null,
                React.createElement(core_1.TableCell, { className: classes.labelSection }, translate('sleepDiary.sleepQuality')),
                data.map(function (day) {
                    var _a, _b;
                    return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection, classes.noPadding) }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.totalSleepMinutes) && ((_b = day.entry) === null || _b === void 0 ? void 0 : _b.totalBedMinutes) ? (React.createElement("span", { className: (0, classnames_1.default)(classes.sleepEfficiency, getQualityScore(day.entry)) }, "".concat(Number(((day.entry.totalSleepMinutes / day.entry.totalBedMinutes)) * 100).toFixed(0), "%"))) : '-'));
                })),
            showFullDetails ? (React.createElement(React.Fragment, null,
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection }, translate('sleepDiary.totalSleepMinutes')),
                    data.map(function (day) {
                        var _a;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: classes.valueSection }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.totalSleepMinutes) ? ((0, dateUtils_1.hourCount)(day.entry.totalSleepMinutes, translate)) : '-'));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.labelSection, classes.divider) },
                        React.createElement("div", { className: classes.labelWrapper },
                            translate('sleepDiary.totalBedMinutes'),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(icons_1.SleepIcon, { className: classes.icons })))),
                    data.map(function (day) {
                        var _a;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection, classes.divider) }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.totalBedMinutes) ? (0, dateUtils_1.hourCount)(day.entry.totalBedMinutes, translate) : ('-')));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection }, translate('sleepDiary.dayView.daytimeActivityRatings')),
                    data.map(function (day) {
                        var _a, _b;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: classes.valueSection }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.daytimeActivityRating) ? (translate("".concat((_b = constants_1.daytimeActivityRatings.find(function (d) { var _a; return d.id === ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.daytimeActivityRating); })) === null || _b === void 0 ? void 0 : _b.label))) : ('-')));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null, translate('sleepDiary.dayView.dayTimeNaps')),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(image_1.SleepSmileyIcon, null)))),
                    data.map(function (day) {
                        var _a, _b, _c;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: classes.valueSection }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.daytimeNaps) && day.entry.daytimeNaps.length > 0 ? day.entry.daytimeNaps.map(function (nap) {
                            var _a;
                            return (React.createElement("div", { key: (_a = nap.sleepTime) === null || _a === void 0 ? void 0 : _a.toString() }, nap.wakeTime && nap.sleepTime
                                ? (React.createElement(React.Fragment, null,
                                    React.createElement("span", null, "".concat((0, dateUtils_1.hourCount)((0, dateUtils_1.getNumberOfMinutes)(nap.sleepTime, nap.wakeTime), translate), " ")),
                                    React.createElement("span", null, "".concat(translate('sleepDiary.dayView.at'), " ").concat((0, dateUtils_1.getTimePartForInput)(nap.sleepTime))))) : (React.createElement("span", null, " - ".concat(translate('sleepDiary.dayView.at'), " ").concat((0, dateUtils_1.getTimePartForInput)(nap.sleepTime))))));
                        }) : ((_c = (_b = day.entry) === null || _b === void 0 ? void 0 : _b.sleepProperties) === null || _c === void 0 ? void 0 : _c.hasDaytimeNaps) === false ? translate('sleepDiary.none') : '-'));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.labelSection, classes.divider) },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null,
                                React.createElement("div", null, translate('sleepDiary.dayView.sleepMedication')),
                                React.createElement("div", null, translate('sleepDiary.dayView.alcohol'))),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(image_1.MedicineIcon, null)))),
                    data.map(function (day) {
                        var _a, _b;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection, classes.divider) }, ((_b = (_a = day.entry) === null || _a === void 0 ? void 0 : _a.sleepProperties) === null || _b === void 0 ? void 0 : _b.sleepMedication) ? (day.entry.sleepProperties.sleepMedication) : ('-')));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null, translate('sleepDiary.dayView.gotToBed')),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(image_1.MoonIcon, null)))),
                    data.map(function (day) {
                        var _a;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection) }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.bedTime) ? (0, dateUtils_1.getTimePartForInput)(day.entry.bedTime) : ('-')));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null, translate('sleepDiary.dayView.tiredToSleep')),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(image_1.SleepSmileyIcon, null)))),
                    data.map(function (day) {
                        var _a;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection) }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.sleepAtemptTime) ? (0, dateUtils_1.getTimePartForInput)(day.entry.sleepAtemptTime) : ('-')));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null, translate('sleepDiary.dayView.fellAsleep')),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(image_1.SleepSmileyIcon, null)))),
                    data.map(function (day) {
                        var _a;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection) }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.sleepTime) ? (0, dateUtils_1.getTimePartForInput)(day.entry.sleepTime) : '-'));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null, translate('sleepDiary.dayView.awake')),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(image_1.AwakeSmileyIcon, null)))),
                    data.map(function (day) {
                        var _a, _b, _c;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection) }, ((_b = (_a = day.entry) === null || _a === void 0 ? void 0 : _a.sleepProperties) === null || _b === void 0 ? void 0 : _b.numberOfNightWakeups) ? ("".concat((_c = day.entry.sleepProperties) === null || _c === void 0 ? void 0 : _c.numberOfNightWakeups, " ").concat(translate('sleepDiary.dayView.times'))) : '-'));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: (0, classnames_1.default)(classes.labelSection, classes.divider) },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null, translate('sleepDiary.nightWakeupsTotalMinutes')),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(image_1.AwakeSmileyIcon, null)))),
                    data.map(function (day) {
                        var _a, _b;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection, classes.divider) }, ((_b = (_a = day.entry) === null || _a === void 0 ? void 0 : _a.sleepProperties) === null || _b === void 0 ? void 0 : _b.nightWakeupsTotalMinutes) ? ("".concat(day.entry.sleepProperties.nightWakeupsTotalMinutes, " ").concat(translate('sleepDiary.dayView.min'))) : ('-')));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null, translate('sleepDiary.dayView.youWokeUp')),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(icons_1.SunIcon, null)))),
                    data.map(function (day) {
                        var _a;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection) }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.wakeTime) ? ((0, dateUtils_1.getTimePartForInput)(day.entry.wakeTime)) : ('-')));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { align: "center", className: classes.labelSection },
                        React.createElement("div", { className: classes.labelWrapper },
                            React.createElement("div", null, translate('sleepDiary.dayView.youGotOutOfBed')),
                            React.createElement("span", { className: classes.icons },
                                React.createElement(image_1.WakeUpIcon, null)))),
                    data.map(function (day) {
                        var _a;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection) }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.outOfBedTime) ? ((0, dateUtils_1.getTimePartForInput)(day.entry.outOfBedTime)) : ('-')));
                    })),
                React.createElement(core_1.TableRow, null,
                    React.createElement(core_1.TableCell, { className: classes.labelSection }, translate('sleepDiary.yourSleepRating')),
                    data.map(function (day) {
                        var _a, _b;
                        return (React.createElement(core_1.TableCell, { key: day.isoDateString, className: (0, classnames_1.default)(classes.valueSection) }, ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.sleepRating) ? (translate(((_b = constants_1.sleepRatings.find(function (d) { var _a; return ((_a = day.entry) === null || _a === void 0 ? void 0 : _a.sleepRating) === d.id; })) === null || _b === void 0 ? void 0 : _b.label) || '', undefined, { onMissingTranslation: function () { var _a, _b; return ((_b = (_a = day.entry) === null || _a === void 0 ? void 0 : _a.sleepRating) === null || _b === void 0 ? void 0 : _b.toString()) || ''; } })) : ('-')));
                    })),
                React.createElement(core_1.TableRow, { className: classes.actionRow },
                    React.createElement(core_1.TableCell, { colSpan: data.length + 1, onClick: function () { return setShowFullDetails(false); }, align: "center" },
                        React.createElement(core_1.Typography, { variant: "button" }, translate('sleepDiary.hideDetails')))))) : (React.createElement(core_1.TableRow, { className: classes.actionRow },
                React.createElement(core_1.TableCell, { colSpan: data.length + 1, onClick: function () { return setShowFullDetails(true); }, align: "center" },
                    React.createElement(core_1.Typography, { variant: "button" }, translate('sleepDiary.showFullDetails'))))))))));
};
exports.default = SleepDetailsTable;
